import React, {useEffect, useState} from "react";
import Logo from '../../../assets/images/mariposaEB_logo_no_background.png'
import LanguageChoices from "../../Common/locales/locales_components/language_choices";
import Menu from "../menu/menu";
import {useTranslation} from "react-i18next";
import {Modal} from "../modal/Modal";
import {subscribeNewsletter} from "../../../api/api";
import {useMediaQuery} from "../../../hooks/useMediaQuery";

const Header = ({ props }: {
    props: {
        activePage: string | null;
        setActivePage: (name: string | null) => void;
        menuOpen: boolean;
        modal: boolean;
        setModal: (modal: boolean) => void;
        submitted: boolean;
        setSubmitted: (submitted: boolean) => void;
    }
}) => {
    const showMotto = useMediaQuery(768);
    const {t} = useTranslation();
    useEffect(() => {
        props.setSubmitted(false)
    }, []);

    return (
        <div className={"title"}>
            <div className={"logo-background"}></div>
            <div className={"no-logo-background"}>
                {showMotto && (
                    <div>
                        <p className={"subtitle"}>{t("header.motto.reveal")}</p>
                        <p className={"subtitle"}>{t("header.motto.welcome")}</p>
                    </div>
                )}
                <LanguageChoices/>
                <button className="btn newsletter-button" onClick={() => props.setModal(true)}>
                    {t('newsletter.title')}
                </button>
                <Menu  props={{
                    activePage:props.activePage,
                    setActivePage:props.setActivePage,
                    menuOpen: props.menuOpen
                }}/>
            </div>
            {props.modal && (
                <Modal
                    message={t("newsletter.title")}
                    fields={[
                        { name: 'firstName', label: `${t("newsletter.firstName")}`},
                        { name: 'email', label: `${t("newsletter.email")}`},
                        { name: 'language', label: `${t("newsletter.language-preference")}`, type: 'language' },
                    ]}
                    confirmLabel={t("testimony.send")}
                    cancelLabel={t("testimony.cancel")}
                    onCancel={() => props.setModal(false)}
                    submitted={props.submitted}
                    confirmationText={t("newsletter.confirmation")}
                    onConfirm={async (data) => {
                        if (!data?.firstName || !data?.email || !data?.language) return;
                        try {
                            const fd = new FormData();
                            fd.append('firstName', data.firstName);
                            fd.append('email', data.email);
                            fd.append('language', data.language);
                            await subscribeNewsletter(fd);
                            props.setSubmitted(true);
                            setTimeout(() => props.setSubmitted(false), 1000);
                            setTimeout(() => props.setModal(false), 1000);

                        } catch (e) { console.error(e); }
                    }}
                />
            )}
        </div>
    )
}

export default Header
